import { useContext, useEffect, useState } from "react"
import Grid from "@mui/material/Unstable_Grid2/Grid2"
import { WebSocketContext } from "../../../../../../Providers/WebSocket/WebSocketContext"
import { Button, Typography } from "@mui/material"
import OneInput from "../../../../../../Components/OneInput/OneInput"
import OneModal from "../../../../../../Components/OneModal/OneModal"
import { OneSwitch } from "../../../../../../Components/OneSwitch/OneSwitch"
import { showNotify } from "../../../../../../Utils/Utils"

const EdicaoCamerasApp = ({ idToEdit, idCentral, openCameraApp, setOpenCameraApp }) => {
    const { addRoute, sendWs } = useContext(WebSocketContext)
    const [formData, setFormData] = useState(null)
    const [initialData, setInitialData] = useState()

    const getCamerasApp = (msg) => {
        if (msg.data.status) {
            setInitialData(msg.data.camera)
        }
    }

    useEffect(() => {
        addRoute("buscarCameraById", getCamerasApp)
        let stringId = idToEdit != null ? `${idToEdit}` : null
        sendWs("buscarCameraById", { id: stringId, condId: idCentral })
    }, [])

    const handleChange = (event) => {
        if (event.target.value != undefined) {
            if (event.target.type == 'checkbox') {
                setFormData({ ...formData, [event.target.name]: event.target.checked })
            } else {
                setFormData({ ...formData, [event.target.name]: event.target.value })
            }
        }
    }

    const responseSumbit = (msg) => {
        if (msg.data.status == "error") {
            showNotify("error", msg.data.message)
        } else if (msg.data.status) {
            showNotify("success", "Dados salvos com sucesso!")
            setOpenCameraApp(false)
            sendWs("buscarTodasCameras", { condId: idCentral })
        } else if (!msg.data.status) {
            showNotify("error", msg.data.message)
        }
    }

    addRoute("editarCamera", responseSumbit)

    const handleSubmit = async (event) => {
        event.preventDefault()

        if (!formData) {
            showNotify("warning", "Nenhuma alteração feita!")
            return
        }

        let data = formData

        if (initialData?.id != null) {
            const newData = { id: initialData?.id }
            for (const prop in initialData) {
                if (Object.hasOwnProperty.call(initialData, prop)) {
                    if (initialData[prop] != data[prop] && data[prop] != undefined) {
                        newData[prop] = data[prop]
                    }
                }
            }
            data = newData

            sendWs("editarCamera", { camera: data })
        }
    }

    return (
        <OneModal
            open={openCameraApp}
            setOpen={setOpenCameraApp}
            titleText="Editar Camera App"
            FooterButtons={FooterButtons}
            fullWidth={true}
            onClose={false}
        >
            <form
                id="camerasApp-form"
                onSubmit={handleSubmit}
                style={{ width: '100%' }}
            >
                {initialData &&
                <Grid xs={12} sx={{ alignItems: 'center' }}>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }}>
                        <Grid md>
                            <Grid container xs={7} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={2}>
                                    <Typography fontSize="13px" fontWeight='400' >Descrição: </Typography>
                                </Grid>
                                <Grid xs={12} md={9.5}>
                                    <OneInput
                                        defaultValue={initialData?.descricao}
                                        maxLength="255"
                                        required
                                        onChange={handleChange}
                                        name={"descricao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md={3}>
                            <Grid xs={7} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.exibe_monitoramento}
                                        onChange={handleChange}
                                        name={"exibe_monitoramento"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Visível Monitoramento </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container py={0.5} xs={12} sx={{ alignItems: 'center' }} rowGap={1}>
                        <Grid md={6}>
                            <Grid container xs={12} md={5} lg={12} sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={3}>
                                    <Typography fontSize="13px" fontWeight='400' >Nome Exibição: </Typography>
                                </Grid>
                                <Grid xs={12} md={8.5}>
                                    <OneInput
                                        defaultValue={initialData?.nome_exibicao}
                                        maxLength="50"
                                        required
                                        onChange={handleChange}
                                        name={"nome_exibicao"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md>
                            <Grid container xs={12} md lg sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md={2}>
                                    <Typography fontSize="13px" fontWeight='400' >Câmera: </Typography>
                                </Grid>
                                <Grid xs md>
                                    <OneInput
                                        defaultValue={initialData?.camera}
                                        maxLength="100"
                                        required
                                        onChange={handleChange}
                                        name={"camera"}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid container xs py={0.5} sx={{ alignItems: 'center' }}>
                        <Grid md={2.5}>
                            <Grid xs={12} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.exibe_no_app}
                                        onChange={handleChange}
                                        name={"exibe_no_app"}
                                    />
                                </Grid>
                                <Grid xs={12} md={9}>
                                    <Typography fontSize="13px" fontWeight='400' >Mostrar no APP </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md={3} >
                            <Grid xs={12} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.exibir_sindico}
                                        onChange={handleChange}
                                        name={"exibir_sindico"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Mostrar APP Síndico </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md={3}>
                            <Grid xs={12} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.gravar_monitoramento}
                                        onChange={handleChange}
                                        name={"gravar_monitoramento"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Gravar câmera </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        <Grid md={3.5}>
                            <Grid xs={12} container sx={{ alignItems: 'center' }}>
                                <Grid xs={12} md>
                                    <OneSwitch
                                        defaultValue={initialData?.exibe_na_web}
                                        onChange={handleChange}
                                        name={"exibe_na_web"}
                                    />
                                </Grid>
                                <Grid xs={12} md={10}>
                                    <Typography fontSize="13px" fontWeight='400' >Disponível para foto cadastro </Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>

                </Grid>
                }
            </form>
        </OneModal>
    )
}

export default EdicaoCamerasApp

const FooterButtons = () => {
    return (
        <Grid container xs={12} sx={{ alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            <span style={{ fontSize: '13px', margin: 0, padding: 0 }}>* Campos obrigatórios!</span>
            <Button color="one_primary" variant="contained" form="camerasApp-form" type="submit">Salvar</Button>
        </Grid>
    )
}
